import type { PanelVariant } from './components/FocusCard'

// Paramètres Opérateur : préférences d'affichage de CETTE tablette (jamais envoyées au serveur). Aucune règle
// métier ici : masquer un bouton ne change ni la détection ni ce qui est enregistré.

export interface OperatorSettings {
  /** Bouton « Profil » de calibration dans l'en-tête (outils temporaires, jamais en production). */
  showProfileButton: boolean
  /** Bouton « Diag » de calibration dans l'en-tête (outils temporaires, jamais en production). */
  showDiagButton: boolean
  /** Bouton « Détection » de calibration dans l'en-tête : drapeaux et zones sur la carte (jamais en production). */
  showDetectionButton: boolean
  /** Bouton « Focus » dans l'en-tête (bascule rapide du style du panneau). */
  showFocusButton: boolean
  /** Style du panneau gauche : A « bloc actif + liste » (1a), B « focus résidence » (1b). */
  panelStyle: PanelVariant
  /** Taille des numéros civiques RECA sur la carte. */
  civicSize: 'normal' | 'large'
  /** Carte stable pendant le travail à une résidence confirmée (symbole près de l'entrée, caméra figée). */
  stabilizeAtResidence: boolean
}

const settingsKey = 'reca-operator-v3.operator-settings'
/** Ancienne clé du style du panneau (avant les Paramètres) : reprise une fois, à la première lecture. */
const legacyVariantKey = 'reca-operator-v3.panel-variant'

export const defaultOperatorSettings: OperatorSettings = {
  showProfileButton: true,
  showDiagButton: true,
  showDetectionButton: true,
  showFocusButton: true,
  panelStyle: '1b',
  civicSize: 'normal',
  stabilizeAtResidence: true,
}

function flag(value: unknown, fallback: boolean): boolean {
  return typeof value === 'boolean' ? value : fallback
}

export function parseOperatorSettings(raw: string | null, legacyVariant: string | null = null): OperatorSettings {
  let stored: Record<string, unknown> = {}
  try {
    const parsed: unknown = raw ? JSON.parse(raw) : {}
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) stored = parsed as Record<string, unknown>
  } catch {
    stored = {}
  }
  const style = stored.panelStyle ?? legacyVariant
  return {
    showProfileButton: flag(stored.showProfileButton, defaultOperatorSettings.showProfileButton),
    showDiagButton: flag(stored.showDiagButton, defaultOperatorSettings.showDiagButton),
    showDetectionButton: flag(stored.showDetectionButton, defaultOperatorSettings.showDetectionButton),
    showFocusButton: flag(stored.showFocusButton, defaultOperatorSettings.showFocusButton),
    panelStyle: style === '1a' ? '1a' : '1b',
    civicSize: stored.civicSize === 'large' ? 'large' : 'normal',
    stabilizeAtResidence: flag(stored.stabilizeAtResidence, defaultOperatorSettings.stabilizeAtResidence),
  }
}

export function readOperatorSettings(): OperatorSettings {
  try {
    return parseOperatorSettings(
      window.localStorage.getItem(settingsKey),
      window.localStorage.getItem(legacyVariantKey),
    )
  } catch {
    return defaultOperatorSettings
  }
}

export function writeOperatorSettings(settings: OperatorSettings): void {
  try {
    window.localStorage.setItem(settingsKey, JSON.stringify(settings))
  } catch {
    // préférence non mémorisée
  }
}
